import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MaterialModule } from './material.module';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AppModalHeaderComponent } from './shared/app-modal-header/app-modal-header.component';
import { TalentmarketDatePipe } from './pipes/talentmarket-date.pipe';
import { TalentmarketGradePipe } from './pipes/talentmarket-grade.pipe';
import { WarningModalComponent } from './shared/warning-modal/warning-modal.component';
import { EnumToTextPipe } from './pipes/enum-to-text.pipe';
import { EnumToArrayPipe } from './pipes/enum-to-array.pipe';
import { StatusModalComponent } from './shared/status-modal-component/status-modal.component';
import { CampaignActivityFeedComponent } from './shared/components/campaign-activity-feed/campaign-activity-feed.component';
import { ApplicantActivityComponent } from './shared/components/applicant-activity/applicant-activity.component';
import { CompanyActivityFeedComponent } from './shared/components/company-activity-feed/company-activity-feed.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CalendarSettingsModalComponent } from './shared/calendar-settings-modal/calendar-settings-modal.component';

@NgModule({
  declarations: [
    PageNotFoundComponent,
    AppModalHeaderComponent,
    TalentmarketDatePipe,
    TalentmarketGradePipe,
    EnumToTextPipe,
    EnumToArrayPipe,
    WarningModalComponent,
    StatusModalComponent,
    CampaignActivityFeedComponent,
    ApplicantActivityComponent,
    CompanyActivityFeedComponent,
    CalendarSettingsModalComponent
  ],
  imports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    NgOptimizedImage,
    MatButtonToggleModule,
    TranslateModule,
    MatProgressSpinnerModule,
    FontAwesomeModule
  ],
  exports: [
    PageNotFoundComponent,
    AppModalHeaderComponent,
    TalentmarketDatePipe,
    TalentmarketGradePipe,
    EnumToTextPipe,
    EnumToArrayPipe,
    WarningModalComponent,
    StatusModalComponent,
    CampaignActivityFeedComponent,
    ApplicantActivityComponent,
    CompanyActivityFeedComponent,
    CalendarSettingsModalComponent,
    TranslateModule,
    NgOptimizedImage,
    CommonModule
  ],
  providers: [TalentmarketDatePipe, TalentmarketGradePipe],
})
export class SharedModule {}
